module.exports = __webpack_public_path__ + "static/media/square.219b6e7a.jpg";